import { createContext, ReactNode, useState } from 'react';
import { EMPTY_FLOORPLAN, Floorplan } from '@domain/floorplan';

import { FloorplanContextValue } from './floorplan.type';

export const FloorplanContext = createContext<FloorplanContextValue>({
  floorplanState: EMPTY_FLOORPLAN,
  updateFloorPlanState: () => {},
  setFloorplanState: () => {},
  resetFloorplanState: () => {},
  isSaveFloorplanButtonClicked: false,
  setIsSaveFloorplanButtonClicked: () => {},
});

export const FloorplanProvider = ({ children }: { children: ReactNode }) => {
  const [floorplanState, setFloorplanState] = useState<Floorplan>(EMPTY_FLOORPLAN);

  const updateFloorPlanState = (props: Partial<Floorplan>) => {
    setFloorplanState({ ...floorplanState, ...props });
  };
  const resetFloorplanState = () => {
    setFloorplanState(EMPTY_FLOORPLAN);
  };
  const [isSaveFloorplanButtonClicked, setIsSaveFloorplanButtonClicked] = useState(false);

  return (
    <FloorplanContext.Provider
      value={{
        floorplanState,
        setFloorplanState,
        resetFloorplanState,
        updateFloorPlanState,
        isSaveFloorplanButtonClicked,
        setIsSaveFloorplanButtonClicked,
      }}>
      {children}
    </FloorplanContext.Provider>
  );
};
